(() => {
  const roots = document.querySelectorAll('[data-mira-reviews]');
  if (!roots.length) return;

  const PER_PAGE = 5;

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);

  const reviewStars = (rating) => `<span class="mira-review-card__stars" aria-label="${rating} out of 5 stars">${'★'.repeat(rating)}${'☆'.repeat(5 - rating)}</span>`;

  const compactPages = (current, total) => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    if (current <= 4) return [1, 2, 3, 4, 5, 'ellipsis', total];
    if (current >= total - 3) return [1, 'ellipsis', total - 4, total - 3, total - 2, total - 1, total];
    return [1, 'ellipsis', current - 1, current, current + 1, 'ellipsis', total];
  };

  roots.forEach(async (root) => {
    if (root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';

    const list = root.querySelector('[data-review-list]');
    const filters = root.querySelector('[data-review-filters]');
    const pagination = root.querySelector('[data-review-pagination]');
    const footer = root.querySelector('[data-review-footer]');
    const status = root.querySelector('[data-review-status]');
    const sort = root.querySelector('[data-review-sort]');
    const url = root.dataset.reviewsUrl;
    let reviews = [];
    let activeFilter = 'all';
    let activeSort = 'featured';
    let page = 1;

    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Reviews unavailable');
      reviews = await response.json();
    } catch (_) {
      if (list) list.innerHTML = '<p class="mira-reviews__loading">Reviews could not be loaded right now.</p>';
      return;
    }

    [5, 4, 3].forEach((rating) => {
      const count = reviews.filter((review) => Number(review.rating) === rating).length;
      const node = root.querySelector(`[data-review-count="${rating}"]`);
      if (node) node.textContent = count.toLocaleString('en-US');
    });

    const render = () => {
      const filtered = activeFilter === 'all'
        ? [...reviews]
        : reviews.filter((review) => Number(review.rating) === Number(activeFilter));

      if (activeSort === 'highest') {
        filtered.sort((a, b) => Number(b.rating) - Number(a.rating));
      } else if (activeSort === 'lowest') {
        filtered.sort((a, b) => Number(a.rating) - Number(b.rating));
      }

      const totalPages = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
      page = Math.min(page, totalPages);
      const start = (page - 1) * PER_PAGE;
      const visible = filtered.slice(start, start + PER_PAGE);

      list.innerHTML = visible.map((review) => `
        <article class="mira-review-card">
          <div class="mira-review-card__top">
            ${reviewStars(Number(review.rating))}
            <span class="mira-review-card__rating">${Number(review.rating)}.0</span>
          </div>
          <p class="mira-review-card__text">${escapeHtml(review.text)}</p>
          <div class="mira-review-card__author">
            <strong>${escapeHtml(review.name)}</strong>
            ${review.verified === true ? '<span class="mira-review-card__verified"><span aria-hidden="true">✓</span> Verified Purchase</span>' : ''}
            <span>${escapeHtml(review.location)}</span>
          </div>
        </article>
      `).join('');

      const end = Math.min(start + PER_PAGE, filtered.length);
      status.textContent = activeFilter === 'all'
        ? `Showing ${start + 1}–${end} of 4500+ reviews`
        : `Showing ${start + 1}–${end} of ${filtered.length.toLocaleString('en-US')} ${activeFilter}-star reviews`;

      const pieces = [];
      pieces.push(`<button type="button" class="mira-page-button mira-page-button--arrow" data-page="${Math.max(1, page - 1)}" ${page === 1 ? 'disabled' : ''} aria-label="Previous review page">‹</button>`);
      compactPages(page, totalPages).forEach((item, index) => {
        if (item === 'ellipsis') {
          pieces.push(`<span class="mira-page-ellipsis" aria-hidden="true">…</span>`);
        } else {
          pieces.push(`<button type="button" class="mira-page-button${item === page ? ' is-active' : ''}" data-page="${item}" ${item === page ? 'aria-current="page"' : ''}>${item}</button>`);
        }
      });
      pieces.push(`<button type="button" class="mira-page-button mira-page-button--arrow" data-page="${Math.min(totalPages, page + 1)}" ${page === totalPages ? 'disabled' : ''} aria-label="Next review page">›</button>`);
      pagination.innerHTML = pieces.join('');
      footer.hidden = false;
    };

    filters.addEventListener('click', (event) => {
      const button = event.target.closest('[data-review-filter]');
      if (!button) return;
      activeFilter = button.dataset.reviewFilter;
      page = 1;
      filters.querySelectorAll('[data-review-filter]').forEach((filterButton) => {
        const active = filterButton === button;
        filterButton.classList.toggle('is-active', active);
        filterButton.setAttribute('aria-pressed', String(active));
      });
      render();
    });

    if (sort) {
      sort.addEventListener('change', () => {
        activeSort = sort.value || 'featured';
        page = 1;
        render();
      });
    }

    pagination.addEventListener('click', (event) => {
      const button = event.target.closest('[data-page]');
      if (!button || button.disabled) return;
      page = Number(button.dataset.page) || 1;
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    render();
  });
})();
